import React, { Component } from 'react';
import { Card, CardBody, Col, Container, Row, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import showResults from '../Show';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import Datatable from 'react-bs-datatable';
import * as myConstClass from '../../../constant.js';
import 'font-awesome/css/font-awesome.min.css';
import "video-react/dist/video-react.css";

class Bulletin_news_view extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bulletin_news: [],
    }
    this.flag = 0;
  }

  componentDidMount() {
    const answer_array = this.props.location.pathname.split('/');
    if (answer_array['3']) {
      fetch(myConstClass.BASE_URL + '/bulletin_news/getBulletinNewsView/' + answer_array['3'])
        .then(response => response.json())
        .then(response =>
          this.setState({ bulletin_news: response })
        )
        .catch(err => console.log(err))
    }

    if (!localStorage.getItem('session_id')) {
      console.log('History:', this.props);
      this.props.history.push('/log_in');
    }

  }

  render() {
    const { bulletin_news } = this.state;
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Bulletin News</h3>
          </Col>
          <ToastContainer enableMultiContainer containerId={'A'} position={toast.POSITION.BOTTOM_LEFT} />
          <ToastContainer enableMultiContainer containerId={'B'} position={toast.POSITION.TOP_RIGHT} />
        </Row>
        <Row>
          <Col md={12} lg={12}>
            <Card>
              <CardBody>
                <Row>
                  <Col md={12} lg={12}>
                    <h3>Details</h3>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={4} lg={4}>
                  </Col>
                </Row>
                <Row>

                  <Col md={8} lg={8} style={{ "margin-bottom": '10px' }}>

                    <Col md={12} lg={12}>
                      <br />
                      <div>
                        <h5 style={{ "margin-bottom": '5px' }}>
                          <b>Title : </b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' ' + bulletin_news.title}
                        </h5>
                        <br />
                        <h5 style={{ "margin-bottom": '5px' }}>

                          <b>Description : </b>&nbsp;&nbsp;<div dangerouslySetInnerHTML={{ __html: bulletin_news.description }}></div>
                        </h5>
                        <br />
                        <h5 style={{ "margin-bottom": '5px' }}>
                          <b>News Date : </b>&nbsp;&nbsp;{' ' + bulletin_news.news_date}
                        </h5>
                        <br />
                        <h5 style={{ "margin-bottom": '5px' }}>
                          <b>Source of news : </b>&nbsp;&nbsp;{' ' + bulletin_news.news_source}
                        </h5>
                        <br />
                        <h5 style={{ "margin-bottom": '5px' }}>
                          <span style={{ "vertical-align": 'top' }}><b>Image : </b></span>&nbsp;&nbsp;&nbsp;&nbsp;
                          <img src={bulletin_news.image_path} alt="bulletin news image" style={{ width: 'auto', maxWidth: '350px' }} />
                        </h5>
                        <br />
                        <h5 style={{ "margin-bottom": '5px' }}>
                          <b>Date/Time : </b>&nbsp;{' ' + bulletin_news.created_at}
                        </h5>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>)
  }
}

export default withTranslation('common')(Bulletin_news_view);
